<template>
  <div>
    <VPopup
      class="bank-account-popup"
      position="bottom"
      :target="target"
      :align="popupAlign"
      :visible="visible"
      :offset="3"
      @close="closePopup"
    >
      <article v-if="hasBankAccount">
        <header>
          Банковские реквизиты
          <VLink
            title="Копировать в реквизиты в буфер"
            @click="copyInfo"
          >
            <template #icon>
              <VIcon material="content_copy" />
            </template>
          </VLink>
        </header>

        <div class="bank-name">
          {{ bankName }}
        </div>

        <div>
          <div class="label">
            Р/c:
          </div>
          <div class="value">
            {{ formattedBankAccount }}
          </div>
        </div>

        <div>
          <div class="label">
            {{ bankLabel }}
          </div>
          <div class="value">
            {{ $core.utils.string.formatWithDelimiter(bankId, 3) }}
          </div>
        </div>

				<div>
					<div class="label">
						SWIFT:
					</div>
					<div class="value">
						{{ swift }}
					</div>
				</div>

        <div>
          <div class="label">
            Кр/с:
          </div>
          <div class="value">
            {{ formattedCorrespondedAccount }}
          </div>
        </div>
      </article>

      <article
        v-else
        class="empty"
      >
        Нет данных
      </article>
    </VPopup>
  </div>
</template>

<style lang="scss" src="./BankAccountPopup.scss" />

<script>
import BankAccount from "@/domains/BankAccounts/BankAccount.ts";
import Partner from "@/domains/Partners/Partner.ts";

export default defineComponent({
	name: 'VBankAccountPopup',

	props: {
		target: {
			type: [String, HTMLElement, Object],
			default: null,
		},
		visible: {
			type: Boolean,
			default: false,
		},
		bankAccount: {
			type: BankAccount,
			default: null,
		},
		partner: {
			type: Partner,
			default: null,
		},
		popupAlign: {
			type: String,
			default: 'left',
		},
	},
	computed: {
		hasBankAccount() {
			return this.$core.utils.isObject(this.bankAccount);
		},

		countryCode() {
			return this.partner.country ? this.partner.country.code	 : '--';
		},

		bankLabel() {
			switch (this.countryCode) {
				case 'RU': {
					return 'БИК:'
				}
				case 'UZ': {
					return 'МФО:';
				}
				default: {
					return 'БИК:';
				}
			}
		},

		account() {
			return this.hasBankAccount ? this.bankAccount.account : '--';
		},

		formattedBankAccount() {
			switch (this.countryCode) {
				case 'RU': {
					return this.$core.utils.regional.ru.formatBankAccount(this.account);
				}
				case 'UZ': {
					return this.$core.utils.regional.uz.formatBankAccount(this.account);
				}
				default: {
					return this.$core.utils.regional.ru.formatBankAccount(this.account);
				}
			}
		},

		bankName() {
			return this.hasBankAccount && this.bankAccount.bank.name ? this.bankAccount.bank.name : '--';
		},

		bankId() {
			return this.hasBankAccount && this.bankAccount.bank.id ? this.bankAccount.bank.id : '--';
		},

		swift() {
			return this.hasBankAccount && this.bankAccount.swift ? this.bankAccount.swift : '--';
		},

		correspondentAccount() {
			return this.hasBankAccount && this.bankAccount.bank.account ? this.bankAccount.bank.account : '--';
		},

		formattedCorrespondedAccount() {
			switch (this.countryCode) {
				case 'RU': {
					return this.$core.utils.regional.ru.formatBankAccount(this.correspondentAccount);
				}
				case 'UZ': {
					return this.$core.utils.regional.uz.formatBankAccount(this.correspondentAccount);
				}
				default: {
					return this.$core.utils.regional.ru.formatBankAccount(this.correspondentAccount);
				}
			}
		}
	},

	methods: {
		closePopup() {
			this.$emit('close');
		},

		copyInfo() {
			let result = `${this.bankName}\n`;
			result += `Р/c: ${this.account}\n`;
			result += `Кр/с: ${this.correspondentAccount}\n`;
			result += `${this.bankLabel}: ${this.bankId}\n`;
			result += `SWIFT: ${this.swift}`;

			this.$core.utils.copyToClipboard(result);
			this.$core.showNotification.success('Скопировано в буфер обмена');
		},
	},
});
</script>
